import { render, staticRenderFns } from "./composantAjoutTransfert.vue?vue&type=template&id=1853ef7c&scoped=true"
import script from "./composantAjoutTransfert.vue?vue&type=script&lang=js"
export * from "./composantAjoutTransfert.vue?vue&type=script&lang=js"
import style0 from "./composantAjoutTransfert.vue?vue&type=style&index=0&id=1853ef7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1853ef7c",
  null
  
)

export default component.exports